/**
 * Spacing Primitives — raw spacing values on a 4px grid.
 */

export const spacingValues = {
  0: "0px",
  1: "2px",
  2: "4px",
  3: "6px",
  4: "8px",
  6: "12px",
  8: "16px",
  10: "20px",
  12: "24px",
  14: "28px",
  16: "32px",
  20: "40px",
  24: "48px",
  32: "64px",
} as const;
